<script setup>
import { computed } from 'vue';
import config from '../config';

defineProps({ modelValue: { type: String, required: true } });
const emit = defineEmits(['update:modelValue']);
const coins = computed(() => [
  { value: 'zec', label: config.coin },
  ...(config.auxTabsEnabled ? config.auxCoins || [] : []).map(coin => ({ value: coin, label: coin })),
]);
</script>

<template>
  <div class="coin-switch" role="group" :aria-label="$t('aux_coin')">
    <span class="coin-switch-label">{{ $t('aux_coin') }}</span>
    <div class="coin-options">
      <button v-for="coin in coins" :key="coin.value" type="button" class="coin-option"
        :class="{ 'is-selected': modelValue === coin.value }" :aria-pressed="modelValue === coin.value"
        @click="emit('update:modelValue', coin.value)">{{ coin.label }}</button>
    </div>
  </div>
</template>

<style scoped>
.coin-switch { display: inline-flex; align-items: center; gap: 10px; flex-wrap: wrap; }
.coin-switch-label { color: rgba(255, 255, 255, .6); font-size: 12px; }
.coin-options { display: inline-flex; flex-wrap: wrap; gap: 3px; padding: 3px; border: 1px solid rgba(255, 255, 255, .12); border-radius: 7px; background: rgba(0, 0, 0, .08); }
.coin-option { min-width: 60px; height: 28px; padding: 0 13px; border-radius: 4px; font-family: inherit; font-size: 13px; font-weight: 600; line-height: 1; color: rgba(255, 255, 255, .7); transition: background .15s, color .15s; }
.coin-option:hover { background: rgba(255, 255, 255, .07); color: #fff; }
.coin-option.is-selected { background: #0d47a1; color: #fff; }
.coin-option:focus-visible { outline: 2px solid #64b5f6; outline-offset: 2px; }
</style>
